import { render, staticRenderFns } from "./ScreenImportAdd.vue?vue&type=template&id=470641df&"
import script from "./ScreenImportAdd.vue?vue&type=script&lang=js&"
export * from "./ScreenImportAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports